import React from 'react';
import { CaretDown } from 'phosphor-react';
import './SStateSelector.css';

export interface SStateSelectorProps {
  state: string;
  onClick?: () => void;
  className?: string;
}

export const SStateSelector: React.FC<SStateSelectorProps> = ({
  state,
  onClick,
  className = '',
}) => {
  return (
    <button
      className={`s-state-selector ${className}`}
      onClick={onClick}
      type="button"
    >
      <span className="s-state-selector-label">{state}</span>
      <CaretDown size={16} color="#111215" />
    </button>
  );
};

export default SStateSelector;
